/** @format */

import { RootState } from "../store/store";

export const selectSandboxCircle = (state: RootState) => state.sandbox.circle;
export const selectSandboxIsLoading = (state: RootState) =>
    state.sandbox.isLoading;
export const selectSandboxError = (state: RootState) => state.sandbox.error;
export const selectSandboxIsMemberUpdating = (state: RootState) =>
    state.sandbox.isMemberUpdating;
export const selectSandboxMemberUpdateError = (state: RootState) =>
    state.sandbox.memberUpdateError;
export const selectSandboxShareResult = (state: RootState) =>
    state.sandbox.shareResult;
export const selectSandboxIsSharing = (state: RootState) =>
    state.sandbox.isSharing;
export const selectSandboxShareError = (state: RootState) =>
    state.sandbox.shareError;
export const selectSandboxIsConverting = (state: RootState) =>
    state.sandbox.isConverting;
export const selectSandboxConvertError = (state: RootState) =>
    state.sandbox.convertError;
